import {cookieStore} from '../libs/storage/storage';

const STORE_ID = '19';
const STORE_ID_ANDROID = '23';
export const AFF_ID = 'gusa_aff_id';
const ANDROID_COOKIE_KEY = 'android';

/**
 * Get store id
 * @param {object} cookie Cookies
 * @returns {STORE_ID | STORE_ID_ANDROID} Store id
 */
export const getStoreId = (cookie: Object | null = null) => {
    if (cookie && (cookie[ANDROID_COOKIE_KEY] || '').toString() === '1') {
        return STORE_ID_ANDROID;
    }
    if (!__NODEJS__ && cookieStore.get(ANDROID_COOKIE_KEY, '').toString() === '1') {
        return STORE_ID_ANDROID;
    }
    return STORE_ID;
};
